module.exports = __webpack_public_path__ + "static/pic05-22d358c87e24814682531a8e4e33dcd6.png";